import { createElement as t, createRef as e, Component as r } from "react";

function n() {
  return (n = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
      }
    }

    return t;
  }).apply(this, arguments);
}

function i(t, e) {
  if (null == t) return {};
  var r,
      n,
      i = {},
      o = Object.keys(t);

  for (n = 0; n < o.length; n++) {
    e.indexOf(r = o[n]) >= 0 || (i[r] = t[r]);
  }

  return i;
}

function o(t, e) {
  return !!t && e !== t.clientWidth;
}

function l(t) {
  return "string" == typeof t && t.length > 0;
}

var s = function (r) {
  var s, c;

  function a() {
    for (var t, n = arguments.length, i = new Array(n), s = 0; s < n; s++) {
      i[s] = arguments[s];
    }

    return (t = r.call.apply(r, [this].concat(i)) || this).isWidthDifferentFn = o, t.state = {
      previousChildren: void 0,
      good: 0,
      current: l(t.props.children) ? t.props.children.split(" ").length : 0,
      bad: null
    }, t.element = e(), t.width = 0, t.updateText = function () {
      var e = function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t),
          r = e.element,
          n = e.state,
          i = n.bad,
          o = n.good,
          l = n.current;

      if (r.current) if ((r.current ? r.current.scrollHeight : 0) > e.props.maxHeight) t.setState(null != i && i - o == 1 ? {
        current: o
      } : {
        current: l - (l - o >> 1),
        bad: l
      });else {
        if (null == i || l === o) return;
        t.setState({
          current: l + (i - l >> 1),
          good: l
        });
      }
    }, t;
  }

  c = r, (s = a).prototype = Object.create(c.prototype), s.prototype.constructor = s, s.__proto__ = c;
  var h = a.prototype;
  return h.componentDidMount = function () {
    this.setState({
      previousChildren: this.props.children
    });
  }, h.componentDidUpdate = function () {
    var t = this.element,
        e = this.props.children,
        r = this.state.previousChildren,
        n = this.isWidthDifferentFn(t.current, this.width);
    t.current && n && (this.width = t.current.clientWidth), r !== e || n ? this.setState({
      previousChildren: this.props.children,
      current: l(this.props.children) ? this.props.children.split(" ").length : 0,
      good: 0,
      bad: null
    }, this.updateText) : requestAnimationFrame(this.updateText);
  }, h.render = function () {
    var e = this.props,
        r = e.children,
        o = e.character,
        s = e.tag,
        c = e.addTitle,
        a = i(e, ["children", "character", "tag", "addTitle"]),
        h = this.state.current,
        u = i(a, ["maxHeight"]),
        p = l(r) ? r.split(" ").slice(0, h).join(" ") : "",
        d = p.split(/\n()/g).map(function (e, r) {
      return e || t("br", {
        key: r
      });
    }),
        f = r && r.length !== p.length && o;
    return t(s, n({
      ref: this.element,
      title: c ? r : null
    }, u), d, f);
  }, a;
}(r);

s.defaultProps = {
  tag: "div",
  character: "…",
  children: "",
  addTitle: !1
};
export default s;